"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreStepForm = void 0;
var _reactHcaptcha = _interopRequireDefault(require("@hcaptcha/react-hcaptcha"));
var _zod = require("@hookform/resolvers/zod");
var _mui = require("@ori-ui/mui");
var _socialIcons = require("@ori-ui/social-icons");
var _commonFormFields = require("@ori/common-form-fields");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _models = require("../../../models");
var _utils = require("../../../utils");
var _FormValidationSummary = require("../../FormValidationSummary");
var _GoogleIcon = require("../../GoogleIcon");
var _PreStepFormStyledComponent = require("./PreStepFormStyledComponent");
var _PublicSponsorBox = require("./PublicSponsorBox");
var _validationSchema = require("./validationSchema");
var _jsxRuntime = require("react/jsx-runtime");
const WrapperCaptcha = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  marginTop: theme.spacing(3),
  textAlign: 'center',
  order: 7
}));
const getCorrectTabIndex = tabIndex => typeof tabIndex === 'number' ? tabIndex + 1 : 0;
const PreStepForm = props => {
  const {
    config,
    isSuccessSubmit,
    captchaRef,
    showCaptcha,
    captchaError,
    captchaConfig,
    onSubmitForm,
    onVerifyCaptcha
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    validationErrorCode,
    referral
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const validationSchema = (0, _validationSchema.useGetSchema)(config);
  const methods = (0, _reactHookForm.useForm)({
    reValidateMode: 'onChange',
    mode: 'all',
    resolver: (0, _zod.zodResolver)(validationSchema)
  });
  const {
    formState,
    watch,
    register,
    setValue
  } = methods;
  const {
    isValid,
    isSubmitted,
    isSubmitting
  } = formState;
  const formValues = watch();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const invalidCodeErrors = customErrors?.filter(er => !Object.keys(formValues).map(val => val.toLowerCase()).includes(er.fieldName?.toLowerCase() ?? ''));
  const socialValidationMessage = (0, _utils.getErrorLocalizationByCode)(validationErrorCode);
  const isShowCustomValidationMessage = Boolean(!isSubmitted && validationErrorCode);
  const loginWithSocialNetwork = loginType => {
    setValue('loginType', loginType);
    setValue('contactEmail', undefined);
    setValue('contactTelephone', undefined);
    setValue('password', undefined);
    methods.clearErrors();
    methods.handleSubmit(onSubmitForm)();
  };
  (0, _react.useEffect)(() => {
    if (formValues.contactEmail) {
      setValue('loginType', 'Email');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed other property
  }, [formValues.contactEmail]);
  (0, _react.useEffect)(() => {
    if (formValues.contactTelephone) {
      setValue('loginType', 'Telephone');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed other property
  }, [formValues.contactTelephone]);

  /* eslint-disable @typescript-eslint/prefer-nullish-coalescing -- we need logical operator || */
  const isAnySocialNetworkAvailable = Boolean(config?.appleLogin?.isAvailable || config?.facebookLogin?.isAvailable || config?.googleLogin?.isAvailable);
  /* eslint-enable @typescript-eslint/prefer-nullish-coalescing -- we need logical operator || */

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHookForm.FormProvider, {
    ...methods,
    children: [isShowCustomValidationMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
      error: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        ...socialValidationMessage
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormValidationSummary.FormValidationSummary, {
      invalidPropertyErrors: invalidCodeErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.StyledForm, {
      noValidate: true,
      autoComplete: "off",
      onSubmit: methods.handleSubmit(onSubmitForm),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
        container: true,
        justifyContent: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.HiddenInput, {
          ...register('loginType')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
          enableLowercaseLetters: true,
          name: "contactEmail",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_Email,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Email
          }),
          customPlaceholder: formatMessage(_models.TranslationKey.Prestep_PlaceholderEmail),
          keyboardType: "email",
          ...config?.contactEmail,
          isMandatory: config?.contactEmail?.validation?.isMandatory,
          maxLengthLimit: config?.contactEmail?.validation?.maxLength,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
          name: "contactTelephone",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_Phone,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Phone
          }),
          labelWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_PhoneWithPrefix,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_PhoneWithPrefix
          }),
          helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_TooltipPhone,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_TooltipPhone
          }),
          helperTextWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_TooltipPhoneWithPrefix,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_TooltipPhoneWithPrefix
          }),
          customPlaceholder: formatMessage(_models.TranslationKey.Prestep_PlaceholderPhone),
          customPlaceholderWithPrefix: formatMessage(_models.TranslationKey.Prestep_PlaceholderPhoneWithPrefix),
          ...config?.contactTelephone,
          isMandatory: config?.contactTelephone?.validation?.isMandatory,
          maxLengthLimit: config?.contactTelephone?.validation?.maxLength,
          customTenant: tenant,
          customErrors: customErrors
        }), referral?.customerId ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PublicSponsorBox.PublicSponsorBox, {
          displayOrder: config?.invitationCode?.displayOrder
        }) : null, config?.invitationCode?.isAvailable && !referral?.customerId ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
          isEditable: true,
          name: "invitationCode",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_InvitationCode,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_InvitationCode
          }),
          helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_InvitationCodeTooltip,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_InvitationCodeTooltip
          }),
          keyboardType: "text",
          ...config.invitationCode,
          customErrors: customErrors
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PasswordFieldByConfig, {
          name: "password",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_Password,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Password
          }),
          customPlaceholder: formatMessage(_models.TranslationKey.Prestep_PlaceholderPassword),
          ...config?.password,
          isMandatory: config?.password?.validation?.isMandatory,
          minLength: config?.password?.validation?.minLength,
          isSubmitting: isSubmitting,
          customErrors: customErrors
        }), config?.legalNoticeText?.isEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
          size: {
            xs: 12,
            sm: 12
          },
          style: {
            order: config.legalNoticeText.displayOrder ?? 7
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.LegalNotice, {
            variant: "caption",
            ...getTestIdProps('prestep-legal-notice'),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.Prestep_LegalNotice,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_LegalNotice,
              values: {
                TermsAndConditions_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                  color: "textPrimary",
                  variant: "caption",
                  href: (0, _contexts.GetContent)(_Localization.ContentKeys.TermsAndConditions_Url),
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                    id: _models.TranslationKey.Prestep_LegalNotice_TermsAndConditions_Label,
                    defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_LegalNotice_TermsAndConditions_Label
                  })
                }),
                PrivacyPolicy_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                  color: "textPrimary",
                  variant: "caption",
                  href: (0, _contexts.GetContent)(_Localization.ContentKeys.PrivacyPolicy_Url),
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                    id: _models.TranslationKey.Prestep_LegalNotice_PrivacyPolicy_Label,
                    defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_LegalNotice_PrivacyPolicy_Label
                  })
                })
              }
            })
          })
        }) : null, showCaptcha ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperCaptcha, {
          children: [captchaError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
            sx: {
              textAlign: 'center',
              marginBottom: 2
            },
            error: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              ...captchaError
            })
          }) : null, captchaConfig?.serviceType === _globalApiClientReact.GlobalSharedRequestValidationDtoServiceType.ChallengeV2 || captchaConfig?.serviceType === _globalApiClientReact.GlobalSharedRequestValidationDtoServiceType.EnterpriseV3 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactGoogleRecaptcha.default, {
            ref: captchaRef,
            size: captchaConfig?.serviceType === 'ChallengeV2' ? 'normal' : 'invisible',
            badge: "inline",
            onChange: token => onVerifyCaptcha(token),
            sitekey: captchaConfig?.siteKey ?? ''
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHcaptcha.default, {
            sitekey: captchaConfig?.siteKey ?? '',
            onVerify: token => onVerifyCaptcha(token)
          })]
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.SubmitButtton, {
          variant: "contained",
          color: "primary",
          type: "submit"
          // eslint-disable-next-line jsx-a11y/tabindex-no-positive -- we need this specific number for current move by tab
          ,

          tabIndex: 4,
          disabled: !isValid || isSubmitting || isSuccessSubmit,
          ...getTestIdProps('submit-btn-preStepForm'),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_Button,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Button
          })
        })]
      })
    }), isAnySocialNetworkAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.Separator, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.TextOr, {
          variant: "body2",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.Prestep_Or,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Or
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PreStepFormStyledComponent.SocialWrapper, {
        children: [config?.googleLogin?.isAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PreStepFormStyledComponent.SocialButtton, {
          color: "default",
          variant: "outlined",
          sx: {
            order: config.googleLogin.displayOrder
          },
          disabled: isSubmitting,
          tabIndex: getCorrectTabIndex(config.googleLogin.displayOrder),
          onClick: () => loginWithSocialNetwork('Google'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.IconWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GoogleIcon.GoogleIcon, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.IconText, {
            variant: "body1",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.Prestep_Google,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Google
            })
          })]
        }) : null, config?.appleLogin?.isAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PreStepFormStyledComponent.SocialButtton, {
          color: "default",
          variant: "outlined",
          sx: {
            order: config.appleLogin.displayOrder
          },
          disabled: isSubmitting,
          tabIndex: getCorrectTabIndex(config.appleLogin.displayOrder),
          onClick: () => loginWithSocialNetwork('Apple'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.IconWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_socialIcons.Apple, {
              sx: {
                fontSize: '29px'
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.IconText, {
            variant: "body1",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.Prestep_Apple,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Apple
            })
          })]
        }) : null, config?.facebookLogin?.isAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PreStepFormStyledComponent.SocialButtton, {
          color: "default",
          variant: "outlined",
          sx: {
            order: config.facebookLogin.displayOrder
          },
          disabled: isSubmitting,
          tabIndex: getCorrectTabIndex(config.facebookLogin.displayOrder),
          onClick: () => loginWithSocialNetwork('Facebook'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.IconWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_socialIcons.Facebook, {
              sx: {
                color: '#1877F2',
                fontSize: '37px'
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreStepFormStyledComponent.IconText, {
            variant: "body1",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.Prestep_Facebook,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Facebook
            })
          })]
        }) : null]
      })]
    }) : null]
  });
};
exports.PreStepForm = PreStepForm;